import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { URL_SERVICIOS_LOCALES } from '../../config/url.servicio'
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

@Injectable()
export class CuentasPorCobrarProvider {
  token:string
  constructor(public http: Http,public storage:Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
  });
  }

  
  // buscar(text:any){
  //   const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarCuentasPorCobrarConSaldo?jsonFiltros=${text}`;
  //   return this.http
  //       .get(url)
  //       .map(data => data.json()[0].map(item => {
  //           return {
  //               display: item.nombre,
  //               value: item.proveedoresId
  //           }
  //       } ));
  // }

  buscar(text:any){
    const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarCuentasPorCobrar?nombre=${text}`;
    return this.http
        .get(url)
        .map(data => data.json()[0].map(item => {
            return {
                display: item.nombre,
                value: item.proveedoresId
            }
        } ));
  }

  buscarCredito(jsonFiltros:any) {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })
    
    const datos = {
        "jsonFiltros": JSON.stringify(jsonFiltros)
    }
 
    return this.http
        .post(`${url}/proceso/buscarCuentasPorCobrarConSaldo`, datos, options)
  }   


}


// ALTER procedure [dbo].[buscarCuentasPorCobrares]
// 	@nombre varchar(80)

// as

// select	(ltrim(rtrim(nombreEmpresa)) + ' - ' + nombre) nombre, proveedoresId
// from	proveedores 
// where	(ltrim(rtrim(nombreEmpresa)) + ' - ' + nombre) like '%'+@nombre+'%'



// WEBPACK FOOTER //
// ./src/providers/cuentas-por-cobrar/cuentas-por-cobrar.ts